import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "booleanToTranslation",
  standalone: true,
})
export class BooleanToTranslationPipe implements PipeTransform {
  transform(value: any): string {
    if (typeof value === "boolean") {
      return value ? "generalOptions.yes" : "generalOptions.no";
    }
    return value;
  }
}
